module.exports = __webpack_public_path__ + "img/login-left.06d9366d.png";